import type {LegalDocumentationHelpLinkConfigType} from '../../provider/help-links/legal-documentation-help-link-config';
import {ShortLocaleNameEnum} from '../../provider/locale/locale-context-type';

export function resolvePrivacyPolicyDocumentationHref(
    config: LegalDocumentationHelpLinkConfigType | null,
    shortLocaleName: ShortLocaleNameEnum
): string {
    const fromConfig = config?.privacyPolicy?.trim();

    if (fromConfig) {
        return fromConfig;
    }

    if (shortLocaleName === ShortLocaleNameEnum.ru) {
        return 'https://rocketdata.ru/consent-registration?_ga=2.185844011.342534258.1626168772-1102103654.1626168772';
    }

    return 'https://rocketdata.io/privacy';
}

export function resolveTermsDocumentationHref(
    config: LegalDocumentationHelpLinkConfigType | null,
    shortLocaleName: ShortLocaleNameEnum
): string {
    const fromConfig = config?.terms?.trim();

    if (fromConfig) {
        return fromConfig;
    }

    if (shortLocaleName === ShortLocaleNameEnum.ru) {
        return 'https://rocketdata.ru/terms_and_conditions?_ga=2.185844011.342534258.1626168772-1102103654.1626168772';
    }

    return 'https://rocketdata.io/terms';
}
